(function () {
'use strict';

var $bonusPointsMeter = $('.js-apn-bonus-points-meter');
if ($bonusPointsMeter.length) {
  (function ($) {
    var $modulator = $('.apn-bonus-scheme__bonus-points__meter__modulator', $bonusPointsMeter);
    var $blur = $('.apn-bonus-scheme__bonus-points__meter__blur', $bonusPointsMeter);
    // const $currentSalePoints = parseInt($('.apn-bonus-scheme__bonus-points__salepoints').html());

    var $currentRank = $('.apn-bonus-scheme__bonus-points__rank');
    // const $pointsLeftToRankUp = $('.apn-bonus-scheme__bonus-points__points-left');
    var rank = void 0;
    var distance = void 0;
    // let pointsLeftToRankUp;
    // let nextRank;
    // let percentageOfRange;
    //
    // if ($currentSalePoints === 0) {
    //   rank = 'Bronze';
    //   distance = 95.5;
    //   pointsLeftToRankUp = 1;
    //   nextRank = 'Silber';
    // }
    // if ($currentSalePoints > 0 && $currentSalePoints < 250) {
    //   rank = 'Silber';
    //   percentageOfRange = 25 * (1 - ($currentSalePoints / 249));
    //   distance = percentageOfRange + 50;
    //   pointsLeftToRankUp = 250 - $currentSalePoints;
    //   nextRank = 'Gold';
    // }
    // if ($currentSalePoints > 249 && $currentSalePoints < 500) {
    //   rank = 'Gold';
    //   percentageOfRange = 25 * (1 - (($currentSalePoints - 249) / 250));
    //   distance = percentageOfRange + 25;
    //   pointsLeftToRankUp = 500 - $currentSalePoints;
    //   nextRank = 'Diamant';
    // }
    // if ($currentSalePoints >= 500) {
    //   rank = 'Diamant';
    //   distance = 4.5;
    // }

    // TODO temporarily use bonus points
    var rankFromBonusPoints = parseInt($currentRank.data('bonusPointsRank'));
    switch (rankFromBonusPoints) {
      case 1:
        rank = 'Silber';
        distance = 5 * 12.5;
        break;
      case 2:
        rank = 'Gold';
        distance = 3 * 12.5;
        break;
      case 3:
        rank = 'Diamant';
        distance = 4.5;
        break;
      default:
        rank = 'Bronze';
        distance = 95.5;
        break;
    }

    $currentRank.html('Ihr Status: ' + rank);
    // if (rank === 'Diamant'){
    //   $pointsLeftToRankUp.html('Glückwunsch! Sie erhalten sämtliche Vorteile!');
    // } else {
    //   $pointsLeftToRankUp.html('Noch ' + pointsLeftToRankUp + ' Status-Taler bis zum ' + nextRank + '-Status mit weiteren Vorteilen');
    // }
    $modulator.css('right', distance + '%');
    $blur.css('width', distance + '%');
  })(jQuery);
}

}());
